import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
//import 'rxjs/add/operator/map';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import { AppService } from '../../app.service';
import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SetAllMemberCheck } from './../../shared/message.event';
import { FeedService } from './../feed.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from './../../constants/constants-messages';
import { UISETTING } from './../../shared/ui-setting';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-feed-list',
    templateUrl: './feed-list.component.html',
    styleUrls: ['./feed-list.component.css'],
    providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, FeedService, SetAllMemberCheck]
})
export class FeedListComponent implements OnInit {
    public appCall: any;
    private _router;
    private _feedService;
    private shouldSlide: boolean = false;
    private feedcomp = 70;
    private clearfeed = 15;
    private vendor;
    private message = '';
    private noFeedbackText = true;
    private clubName = '';
    private categoryList = CONSTANT_VALUES.CATEGORY_LIST_FOR_FEED;
    private category = 'BROADCAST';
    private feedList = [];
    private exp = false;
    private searchKey = '';
    private memberListForBroadcast = [];
    private groupListForBroadcast = [];
    private isopen = false;
    private noFeedAddedMessages = CONSTANT_MESSAGES.NO_FEED_ADDED_MESSAGE;
    private uiSetting: UISETTING;
    private height: any;
    private scrollOptions: ISlimScrollOptions;
    private utilityFunctions = new UtilityFunctions();
    constructor(private router: Router, private appService: AppService,
        private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private facilityListEvent: FacilityListEvent, private openFrameEvent: OpenFrameEvent, private feedService: FeedService, private setAllMemberCheck: SetAllMemberCheck) {
        this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 40
        }
        this._router = router;
        this._feedService = feedService;
        this.scrollOptions = {
            barBackground: "#343a40", barOpacity: "0.6", position: "right",
            barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
        };
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.feedcomp + this.clearfeed)) + 'px';
    }

    ngOnInit() {
        this.emitOpenFrameEvent();
        window.scrollTo(0, 0);
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.clubName = subVendor.clubName;
            }
        } else {
            this.clubName = this.vendor.clubName;
        }
        this.getFeedByVendor();

        this.registerTypeBroadcast();
        this.emitTypeBroadcast();
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster  
     */
    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }

    /**
     * function show menu at facility page by broadcaster
     */

    emitTypeBroadcast() {
        this.signInEvent.fire('block');
    }

    emitTypeLoaderBroadcast() {
        this.loaderEvent.fire(false);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    selectCategory(para) {
        this.category = para;
        let that = this;
        setTimeout(function () {
            that.getFeedByVendor();
        }, 100);
        this.isopen = false
    }
    /**
     * Get feed list as per condo
     * 
     * 
     * @memberof FeedListComponent
     */
    getFeedByVendor() {
        let that = this;
        let vendorObj = {
            vendorId: this.vendor._id,
            type: this.category
        }
        this.loaderEvent.fire(false);
        this._feedService.getFeedByVendor(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.feedList = result.data;
                this.feedList = this.feedList.filter(function (rec: any) {
                    rec.sendOn = that.utilityFunctions.maketimeZoneOfsetDate(rec.sendOn) ? that.utilityFunctions.maketimeZoneOfsetDate(rec.sendOn).format('dddd, MMM DD, YYYY') : '';
                    if (rec.sendToAllMembers) {
                        rec.sendTo = 'All Members';
                    } else if (rec.members.length > 0) {
                        rec.sendTo = 'Specific Members'
                    } else if (rec.sendToAllGroups) {
                        rec.sendTo = 'All Groups';
                    } else if (rec.groups.length > 0) {
                        rec.sendTo = 'Specific Groups';
                    }
                    if (rec.type === 'BROADCAST' && !rec.imageUrl) {
                        rec.imageUrl = '../../../../assets/images/placeholder.png';
                    } else {
                    }
                    if (rec.type === 'ALERT') {
                        rec.facilityName = (rec.facilities[0]).name;
                    }
                    return rec;
                });
            } else {
            }
            if (this.feedList.length === 0) {
                this.noFeedbackText = false;
            } else {
                this.noFeedbackText = true;
            }
            this.loaderEvent.fire(true);
            console.log(this.feedList);
        });
    }

    expand() {
        this.exp = !this.exp;
    }
    /**
     * 
     * 
     * @param {any} popupObj 
     * @param {any} feed 
     * @param {any} groupPopup 
     * 
     * @memberof FeedListComponent
     */
    showRecipients(popupObj, feed, groupPopup) {
        switch (feed.sendTo) {
            case 'Specific Members':
                this.memberListForBroadcast = feed.members;
                popupObj.showChildModal();
                break;
            case 'Specific Groups':
                this.groupListForBroadcast = feed.groups;
                groupPopup.showChildModal();
                break;
        }

    }

    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

}



// WEBPACK FOOTER //
// ./src/app/feed/feed-list/feed-list.component.ts